/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { emailTemplatesStore } from '../../axios/emailTemplatesStore'
import type {
	EmailTemplatesStoreError,
	EmailTemplatesStoreRequest,
	EmailTemplatesStoreResponse,
} from '../../types/EmailTemplatesStore'

export const emailTemplatesStoreMutationKey = () => [{ url: '/email-templates' }] as const

export type EmailTemplatesStoreMutationKey = ReturnType<typeof emailTemplatesStoreMutationKey>

export type EmailTemplatesStoreVariables = {
	data: EmailTemplatesStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::store */
export function useEmailTemplatesStore<TContext = unknown>(
	options?: UseMutationOptions<
		EmailTemplatesStoreResponse,
		AxiosError<EmailTemplatesStoreError>,
		EmailTemplatesStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: emailTemplatesStoreMutationKey(),
		mutationFn: ({ data }: EmailTemplatesStoreVariables) => emailTemplatesStore(data, config).then(res => res.data),
		...options,
	})
}
